<h1 class="card-title table-card-title">Story Sessions</h1>
<div class="table-card" *ngIf="tableReady">
    <table>
        <tr>
            <th *ngFor="let column of displayedColumns" class="font-title">
                {{column | translate}}
            </th>
        </tr>
        <tr *ngFor="let row of pageOfItems">
            <td class="arabic-story-name">
                {{row.storybookName}}
            </td>
            <td *ngIf="row.studentUsername" class="font-title">
                {{row.studentUsername}}
            </td>
            <td *ngIf="!row.studentUsername" class="font-title">
                Teacher
            </td>
            <td class="font-title">
                {{row.expPointsEarned}}
            </td>
            <td class="font-title"> 
                {{row.createdDate | date}}
            </td>
        </tr>
    </table>
    <div class="pag-card font-title">
        <jw-pagination [items]="storySessions" (changePage)="onChangePage($event)"></jw-pagination>
    </div>
</div>
